module.exports = __webpack_public_path__ + "img/29d4607c234bfc3655773e9bb3f703bd.svg";